// extracted by mini-css-extract-plugin
export default {"addSongWraper":"AddSong_addSongWraper__crhWS","formError":"AddSong_formError__oiN42","input":"AddSong_input__NE06g","submitButton":"AddSong_submitButton__E3ENI"};